import MarketOpenAccountComponent from './MarketOpenAccountContainer';

export default MarketOpenAccountComponent;
